// import React from "react";
// import {
//   AppBar,
//   Toolbar,
//   Typography,
//   Button,
//   Box,
//   Container,
//   TextField,
//   Grid,
//   Card,
//   CardContent,
// } from "@mui/material";
// import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// import { LockOpen } from "@mui/icons-material";

// /* ========= Purple Theme Tokens ========= */
// const COLORS = {
//   bgGradient:
//     "linear-gradient(135deg, #f5e9ff 0%, #e7dbff 40%, #f7f4ff 100%)",
//   bgGradientDeep:
//     "linear-gradient(135deg, #e9ddff 0%, #d9c7ff 45%, #efe9ff 100%)",
//   textPrimary: "#2a0f4c",                // deep purple for headings
//   textSecondary: "rgba(42,15,76,0.7)",   // body
//   primary: "#8a4fff",
//   primaryHover: "#6a2dd9",
//   primaryLight: "rgba(138,79,255,0.12)",
//   glassBg: "rgba(255,255,255,0.75)",
//   glassShadow: "0 10px 30px rgba(138,79,255,0.18)",
// };

// export default function App() {
//   const products = [
//     {
//       title: "Cloud GPU",
//       desc:
//         "Large-scale dedicated clusters and on-demand VMs with AMD and NVIDIA GPUs",
//       price: "Starting at $0.03/hour",
//       img: "/gpu.png",
//     },
//     {
//       title: "Cloud Compute",
//       desc:
//         "Affordable, powerful virtual machines for enterprise to developer workloads",
//       price: "Starting at $2.50/month",
//       img: "/compute.png",
//     },
//     {
//       title: "Optimized Cloud Compute",
//       desc: "No noisy neighbors on these powerful VMs with built-in NVMe SSD",
//       price: "Starting at $28.00/month",
//       img: "/optimized.png",
//     },
//     {
//       title: "Bare Metal",
//       desc:
//         "Fully automated dedicated servers with zero virtualization layer",
//       price: "Starting at $120.00/month",
//       img: "/baremetal.png",
//     },
//   ];

//   return (
//     <Box
//       sx={{
//         position: "relative",
//         minHeight: "100vh",
//         color: COLORS.textPrimary,
//         background: COLORS.bgGradient,
//         overflow: "hidden",
//       }}
//     >
//       {/* ===== Navbar (glass + purple text) ===== */}
//       <AppBar
//         position="sticky"
//         elevation={0}
//         sx={{
//           bgcolor: "transparent",
//           backgroundImage: "none",
//           mt: 1.5,
//         }}
//       >
//         <Toolbar
//           sx={{
//             mx: "auto",
//             width: "100%",
//             maxWidth: "1200px",
//             borderRadius: "16px",
//             px: 3,
//             py: 1.2,
//             backdropFilter: "blur(10px)",
//             background: "rgba(255,255,255,0.6)",
//             boxShadow: COLORS.glassShadow,
//             display: "flex",
//             justifyContent: "space-between",
//           }}
//         >
//           {/* Left: Logo + Nav */}
//           <Box sx={{ display: "flex", alignItems: "center", gap: 3 }}>
//             <img src="/ainova_logo_white.png" alt="Logo" style={{ height: 36 }} />

//             <Box sx={{ display: "flex", alignItems: "center", gap: 3 }}>
//               {[
//                 "Products",
//                 "Features",
//                 "Marketplace",
//                 "Pricing",
//                 "Partners",
//                 "Company",
//               ].map((item, i) => (
//                 <Box
//                   key={i}
//                   sx={{
//                     display: "flex",
//                     alignItems: "center",
//                     gap: 0.5,
//                     color: COLORS.textPrimary,
//                     fontFamily: "Inter, Helvetica, Arial, sans-serif",
//                     fontSize: "0.95rem",
//                     fontWeight: 600,
//                     cursor: "pointer",
//                     px: 0.5,
//                     py: 0.25,
//                     borderRadius: "8px",
//                     transition: "background 0.2s ease",
//                     "&:hover": { background: COLORS.primaryLight },
//                   }}
//                 >
//                   {item}
//                   {["Products", "Features", "Marketplace", "Partners", "Company"].includes(item) && (
//                     <ExpandMoreIcon sx={{ fontSize: "1.1rem", opacity: 0.7 }} />
//                   )}
//                 </Box>
//               ))}
//             </Box>
//           </Box>

//           {/* Right: Auth buttons */}
//           <Box sx={{ display: "flex", gap: 1 }}>
//             <NavButton text="Log in" variant="outlined" />
//             <NavButton text="Sign up" variant="contained" />
//             <NavButton text="Contact Sales" variant="bright" />
//           </Box>
//         </Toolbar>
//       </AppBar>

//       {/* ===== Hero (lavender gradient) ===== */}
//       <Container sx={{ textAlign: "center", py: 10, maxWidth: "1100px" }}>
//         <Typography
//           variant="h3"
//           sx={{
//             fontFamily: "Inter, Helvetica, Arial, sans-serif",
//             fontWeight: 800,
//             color: COLORS.textPrimary,
//             letterSpacing: 0.2,
//             mb: 3,
//             lineHeight: 1.15,
//           }}
//         >
//           POWERING THE NEW ERA WITH
//           <br />
//           STATE-OF-THE-ART
//           <br />
//           TAILORED SOLUTIONS
//         </Typography>

//         <Typography
//           variant="h6"
//           sx={{
//             color: COLORS.textSecondary,
//             maxWidth: 760,
//             mx: "auto",
//             mb: 5,
//           }}
//         >
//           Global, automated cloud infrastructure from the broadest array of AMD
//           and NVIDIA GPUs to virtual CPUs, bare metal, Kubernetes, storage, and
//           networking solutions.
//         </Typography>

//         {/* Sign-up row */}
//         <Box
//           sx={{
//             display: "flex",
//             justifyContent: "center",
//             flexWrap: "wrap",
//             gap: 2,
//           }}
//         >
//           <GlassInput label="Email Address" />
//           <GlassInput label="Password" type="password" />
//           <Button
//             startIcon={<LockOpen />}
//             sx={{
//               background: `linear-gradient(90deg, ${COLORS.primary} 0%, ${COLORS.primaryHover} 100%)`,
//               color: "#fff",
//               fontFamily: "Inter, Helvetica, Arial, sans-serif",
//               fontWeight: 700,
//               fontSize: "0.95rem",
//               textTransform: "none",
//               px: 3.2,
//               py: 1.2,
//               borderRadius: "12px",
//               boxShadow: "0 8px 24px rgba(138,79,255,0.35)",
//               "&:hover": {
//                 background: `linear-gradient(90deg, ${COLORS.primaryHover} 0%, ${COLORS.primary} 100%)`,
//                 boxShadow: "0 8px 28px rgba(138,79,255,0.45)",
//               },
//             }}
//           >
//             Create Account
//           </Button>
//         </Box>
//       </Container>

//       {/* ===== Product Cards (glassmorphism) ===== */}
//       <Box
//         sx={{
//           position: "relative",
//           mt: -6,
//           pt: 10,
//           pb: 10,
//           background: COLORS.bgGradientDeep,
//           clipPath: "polygon(0 64px, 100% 0, 100% 100%, 0% 100%)",
//         }}
//       >
//         <Container maxWidth="xl">
//           <Grid
//             container
//             spacing={3}
//             justifyContent="center"
//             alignItems="stretch"
//             sx={{
//               flexWrap: "nowrap",
//               overflowX: "auto",
//               scrollbarWidth: "none",
//               "&::-webkit-scrollbar": { display: "none" },
//             }}
//           >
//             {products.map((p, index) => (
//               <Grid
//                 item
//                 key={index}
//                 sx={{
//                   flex: "0 0 25%",
//                   minWidth: "300px",
//                   display: "flex",
//                   justifyContent: "center",
//                 }}
//               >
//                 <Card
//                   sx={{
//                     width: "100%",
//                     maxWidth: 340,
//                     borderRadius: "14px",
//                     backdropFilter: "blur(10px)",
//                     background: COLORS.glassBg,
//                     boxShadow: COLORS.glassShadow,
//                     transition: "transform 0.25s ease, box-shadow 0.25s ease",
//                     textAlign: "center",
//                     "&:hover": {
//                       transform: "translateY(-6px)",
//                       boxShadow: "0 16px 40px rgba(138,79,255,0.28)",
//                     },
//                   }}
//                 >
//                   <CardContent sx={{ p: 4 }}>
//                     <Box
//                       component="img"
//                       src={p.img}
//                       alt={p.title}
//                       sx={{
//                         width: 100,
//                         height: 100,
//                         mb: 2,
//                         objectFit: "contain",
//                         mx: "auto",
//                         display: "block",
//                       }}
//                     />
//                     <Typography
//                       variant="h6"
//                       sx={{
//                         fontFamily: "Inter, Helvetica, Arial, sans-serif",
//                         fontWeight: 700,
//                         fontSize: "1.05rem",
//                         color: COLORS.textPrimary,
//                         mb: 1,
//                       }}
//                     >
//                       {p.title}
//                     </Typography>
//                     <Typography
//                       variant="body2"
//                       sx={{
//                         fontFamily: "Inter, Helvetica, Arial, sans-serif",
//                         fontSize: "0.95rem",
//                         color: COLORS.textSecondary,
//                         mb: 2,
//                         lineHeight: 1.55,
//                       }}
//                     >
//                       {p.desc}
//                     </Typography>
//                     <Typography
//                       variant="body2"
//                       sx={{
//                         fontFamily: "Inter, Helvetica, Arial, sans-serif",
//                         fontWeight: 700,
//                         fontSize: "0.95rem",
//                         color: COLORS.primary,
//                       }}
//                     >
//                       {p.price}
//                     </Typography>
//                   </CardContent>
//                 </Card>
//               </Grid>
//             ))}
//           </Grid>
//         </Container>
//       </Box>

//       {/* OUR STATEMENTS Section */}
//       <Box
//         sx={{
//           py: 10,
//           background: "linear-gradient(135deg, #f5e9ff 0%, #ece0ff 40%, #f9f6ff 100%)",
//         }}
//       >
//         <Container maxWidth="md">

//           {/* Glass Box Wrapper */}
//           <Box
//             sx={{
//               borderRadius: "16px",
//               background:
//                 "linear-gradient(135deg, rgba(243,230,255,0.9) 0%, rgba(230,215,255,0.75) 50%, rgba(248,244,255,0.9) 100%)",
//               boxShadow: "0 12px 40px rgba(138,79,255,0.15)",
//               backdropFilter: "blur(12px)",
//               p: 6,
//               display: "flex",
//               flexDirection: "column",
//               gap: 5,
//             }}
//           >
//             {/* Vision */}
//             <Box sx={{ display: "flex", alignItems: "flex-start", gap: 3 }}>
//               <Box
//                 sx={{
//                   minWidth: 60,
//                   height: 60,
//                   borderRadius: "10px",
//                   background:
//                     "linear-gradient(135deg, #b48bff 0%, #8a63e8 100%)",
//                   display: "flex",
//                   justifyContent: "center",
//                   alignItems: "center",
//                   boxShadow: "0 6px 20px rgba(138,79,255,0.3)",
//                 }}
//               >
//                 <Typography sx={{ fontSize: "1.8rem", color: "#fff" }}>✓</Typography>
//               </Box>

//               <Box>
//                 <Typography
//                   variant="h6"
//                   sx={{
//                     fontFamily: "Inter, Helvetica, Arial, sans-serif",
//                     fontWeight: 800,
//                     color: "#1a1b4b",
//                     mb: 0.5,
//                   }}
//                 >
//                   OUR VISION
//                 </Typography>
//                 <Typography
//                   variant="body1"
//                   sx={{
//                     fontFamily: "Inter, Helvetica, Arial, sans-serif",
//                     color: "#1a1b4b",
//                     lineHeight: 1.6,
//                   }}
//                 >
//                   <strong>AI NOVA</strong> aims to be the global leader in Computing
//                   Power Services, empowering enterprises with next-generation
//                   infrastructure to excel in an ever-evolving digital world. Guided by
//                   relentless innovation and an unwavering commitment to our customers,
//                   we are shaping the future of intelligent computing, delivering the
//                   performance, scalability, and insight that define tomorrow’s digital
//                   enterprise.
//                 </Typography>
//               </Box>
//             </Box>

//             {/* Mission */}
//             <Box sx={{ display: "flex", alignItems: "flex-start", gap: 3 }}>
//               <Box
//                 sx={{
//                   minWidth: 60,
//                   height: 60,
//                   borderRadius: "10px",
//                   background:
//                     "linear-gradient(135deg, #b48bff 0%, #8a63e8 100%)",
//                   display: "flex",
//                   justifyContent: "center",
//                   alignItems: "center",
//                   boxShadow: "0 6px 20px rgba(138,79,255,0.3)",
//                 }}
//               >
//                 <Typography sx={{ fontSize: "1.8rem", color: "#fff" }}>✓</Typography>
//               </Box>

//               <Box>
//                 <Typography
//                   variant="h6"
//                   sx={{
//                     fontFamily: "Inter, Helvetica, Arial, sans-serif",
//                     fontWeight: 800,
//                     color: "#1a1b4b",
//                     mb: 0.5,
//                   }}
//                 >
//                   OUR MISSION
//                 </Typography>
//                 <Typography
//                   variant="body1"
//                   sx={{
//                     fontFamily: "Inter, Helvetica, Arial, sans-serif",
//                     color: "#1a1b4b",
//                     lineHeight: 1.6,
//                   }}
//                 >
//                   <strong>AI NOVA</strong> is committed to accelerating enterprise
//                   digital transformation through innovative technologies that create
//                   measurable value for our customers. By leveraging
//                   state-of-the-art computing infrastructure and deep domain expertise,
//                   we empower organizations to achieve superior performance, optimize
//                   operations, and scale effectively — driving synergy, resilience, and
//                   impact across today’s dynamic digital landscape.
//                 </Typography>
//               </Box>
//             </Box>
//           </Box>
//         </Container>
//       </Box>

//       {/* EMPOWERING OUR CUSTOMERS Section */}
//       {/* EMPOWERING OUR CUSTOMERS Section (One Row Layout) */}
//       <Box
//         sx={{
//           py: 5,
//           background: "linear-gradient(135deg, #f6edff 0%, #efe3ff 40%, #faf7ff 100%)",
//         }}
//       >
//         <Container maxWidth="lg">
//           {/* Heading */}
//           <Typography
//             variant="h4"
//             sx={{
//               fontFamily: "Inter, Helvetica, Arial, sans-serif",
//               fontWeight: 800,
//               color: "#1a1b4b",
//               mb: 1,
//               textAlign: "center",
//             }}
//           >
//             EMPOWERING OUR CUSTOMERS
//           </Typography>
//           <Typography
//             variant="subtitle1"
//             sx={{
//               fontFamily: "Inter, Helvetica, Arial, sans-serif",
//               fontWeight: 600,
//               color: "rgba(26,27,75,0.8)",
//               mb: 2,
//               textAlign: "center",
//             }}
//           >
//             OUR CORE PILLARS
//           </Typography>

//           {/* Grid layout - 3 cards in 1 row */}
//           <Grid
//             container
//             spacing={4}
//             justifyContent="center"
//             alignItems="stretch"
//           >
//             {/* 1️⃣ Intelligent Data Center */}
//             <Grid item xs={12} md={4}>
//               <Box
//                 sx={{
//                   borderRadius: "16px",
//                   background:
//                     "linear-gradient(180deg, rgba(240,226,255,0.9) 0%, rgba(255,255,255,0.95) 100%)",
//                   boxShadow: "0 10px 30px rgba(138,79,255,0.15)",
//                   p: 4,
//                   textAlign: "center",
//                   height: "100%",
//                   display: "flex",
//                   flexDirection: "column",
//                   justifyContent: "space-between",
//                 }}
//               >
//                 <Box>
//                   <Box
//                     sx={{
//                       width: 90,
//                       height: 90,
//                       borderRadius: "10px",
//                       background: "linear-gradient(135deg, #9c79ff 0%, #7a5df1 100%)",
//                       mx: "auto",
//                       mb: 3,
//                       display: "flex",
//                       justifyContent: "center",
//                       alignItems: "center",
//                     }}
//                   >
//                     <Typography sx={{ fontSize: "2rem", color: "#fff" }}>💡</Typography>
//                   </Box>
//                   <Typography
//                     variant="h6"
//                     sx={{
//                       fontFamily: "Inter, Helvetica, Arial, sans-serif",
//                       fontWeight: 800,
//                       color: "#1a1b4b",
//                       mb: 2,
//                     }}
//                   >
//                     INTELLIGENT DATA CENTER
//                   </Typography>
//                   <Typography
//                     variant="body2"
//                     sx={{
//                       fontFamily: "Inter, Helvetica, Arial, sans-serif",
//                       color: "rgba(26,27,75,0.85)",
//                       lineHeight: 1.6,
//                       mb: 1,
//                       maxWidth: 250,
//                       textAlign: "left",
//                     }}
//                   >
//                     Our infrastructure empowers enterprises to scale efficiently,
//                     offering cutting-edge hardware and accelerating deployment.
//                     Provision of high-performance physical server leasing for
//                     cross-border enterprises. Equipped with top-tier GPU hardware and
//                     multi-node Tier IV data centers for demanding AI, trading, and
//                     rendering workloads.
//                   </Typography>
//                 </Box>
//                 <Button
//                   sx={{
//                     alignSelf: "center",
//                     mt: "auto",
//                     background: "linear-gradient(90deg, #8a4fff 0%, #6a2dd9 100%)",
//                     color: "#fff",
//                     textTransform: "none",
//                     borderRadius: "40px",
//                     px: 4,
//                     py: 0.8,
//                     fontWeight: 600,
//                     "&:hover": {
//                       background: "linear-gradient(90deg, #6a2dd9 0%, #8a4fff 100%)",
//                     },
//                   }}
//                 >
//                   Enable
//                 </Button>
//               </Box>
//             </Grid>

//             {/* 2️⃣ Enterprise Enablement */}
//             <Grid item xs={12} md={4}>
//               <Box
//                 sx={{
//                   borderRadius: "16px",
//                   background:
//                     "linear-gradient(180deg, rgba(245,222,255,0.9) 0%, rgba(255,255,255,0.95) 100%)",
//                   boxShadow: "0 10px 30px rgba(170,79,255,0.15)",
//                   p: 4,
//                   textAlign: "center",
//                   height: "100%",
//                   display: "flex",
//                   flexDirection: "column",
//                   justifyContent: "space-between",
//                 }}
//               >
//                 <Box>
//                   <Box
//                     sx={{
//                       width: 90,
//                       height: 90,
//                       borderRadius: "10px",
//                       background: "linear-gradient(135deg, #b86cff 0%, #8a3cf1 100%)",
//                       mx: "auto",
//                       mb: 3,
//                       display: "flex",
//                       justifyContent: "center",
//                       alignItems: "center",
//                     }}
//                   >
//                     <Typography sx={{ fontSize: "2rem", color: "#fff" }}>🤖</Typography>
//                   </Box>
//                   <Typography
//                     variant="h6"
//                     sx={{
//                       fontFamily: "Inter, Helvetica, Arial, sans-serif",
//                       fontWeight: 800,
//                       color: "#1a1b4b",
//                       mb: 2,
//                     }}
//                   >
//                     ENTERPRISE ENABLEMENT
//                   </Typography>
//                   <Typography
//                     variant="body2"
//                     sx={{
//                       fontFamily: "Inter, Helvetica, Arial, sans-serif",
//                       color: "rgba(26,27,75,0.85)",
//                       lineHeight: 1.6,
//                       mb: 3,
//                       maxWidth: 250,
//                       textAlign: "left",
//                     }}
//                   >
//                     We design scalable and agile compute, storage, networking, and
//                     data architectures to optimize and future-proof infrastructure.
//                     24/7 proactive monitoring, AI-driven predictive maintenance, and
//                     automated optimization ensure continuous availability and
//                     resilience.
//                   </Typography>
//                 </Box>
//                 <Button
//                   sx={{
//                     alignSelf: "center",
//                     mt: "auto",
//                     background: "linear-gradient(90deg, #b86cff 0%, #8a3cf1 100%)",
//                     color: "#fff",
//                     textTransform: "none",
//                     borderRadius: "40px",
//                     px: 4,
//                     py: 0.8,
//                     fontWeight: 600,
//                     "&:hover": {
//                       background: "linear-gradient(90deg, #8a3cf1 0%, #b86cff 100%)",
//                     },
//                   }}
//                 >
//                   Operate
//                 </Button>
//               </Box>
//             </Grid>

//             {/* 3️⃣ Low Latency Connectivity */}
//             <Grid item xs={12} md={4}>
//               <Box
//                 sx={{
//                   borderRadius: "16px",
//                   background:
//                     "linear-gradient(180deg, rgba(255,220,240,0.9) 0%, rgba(255,255,255,0.95) 100%)",
//                   boxShadow: "0 10px 30px rgba(255,79,165,0.15)",
//                   p: 4,
//                   textAlign: "center",
//                   height: "100%",
//                   display: "flex",
//                   flexDirection: "column",
//                   justifyContent: "space-between",
//                 }}
//               >
//                 <Box>
//                   <Box
//                     sx={{
//                       width: 90,
//                       height: 90,
//                       borderRadius: "10px",
//                       background: "linear-gradient(135deg, #ff6cb2 0%, #e44291 100%)",
//                       mx: "auto",
//                       mb: 3,
//                       display: "flex",
//                       justifyContent: "center",
//                       alignItems: "center",
//                     }}
//                   >
//                     <Typography sx={{ fontSize: "2rem", color: "#fff" }}>🌐</Typography>
//                   </Box>
//                   <Typography
//                     variant="h6"
//                     sx={{
//                       fontFamily: "Inter, Helvetica, Arial, sans-serif",
//                       fontWeight: 800,
//                       color: "#1a1b4b",
//                       mb: 2,
//                     }}
//                   >
//                     LOW LATENCY CONNECTIVITY
//                   </Typography>
//                   <Typography
//                     variant="body2"
//                     sx={{
//                       fontFamily: "Inter, Helvetica, Arial, sans-serif",
//                       color: "rgba(26,27,75,0.85)",
//                       lineHeight: 1.6,
//                       mb: 3,
//                       maxWidth: 250,
//                       textAlign: "left",
//                     }}
//                   >
//                     Our scalable, high-performance connectivity solutions meet the
//                     complex demands of global enterprises, providing low-latency,
//                     cost-effective networking through cutting-edge telecom
//                     infrastructure and optimized routing.
//                   </Typography>
//                 </Box>
//                 <Button
//                   sx={{
//                     alignSelf: "center",
//                     mt: "auto",
//                     background: "linear-gradient(90deg, #ff6cb2 0%, #e44291 100%)",
//                     color: "#fff",
//                     textTransform: "none",
//                     borderRadius: "40px",
//                     px: 4,
//                     py: 0.8,
//                     fontWeight: 600,
//                     "&:hover": {
//                       background: "linear-gradient(90deg, #e44291 0%, #ff6cb2 100%)",
//                     },
//                   }}
//                 >
//                   Connect
//                 </Button>
//               </Box>
//             </Grid>
//           </Grid>
//         </Container>
//       </Box>

//       {/* ===== Regions Section (light purple) ===== */}
//       <Box sx={{ textAlign: "center", color: COLORS.textPrimary }}>
//         <Container maxWidth="lg" sx={{ py: 10 }}>
//           <Typography
//             variant="h4"
//             sx={{
//               fontFamily: "Inter, Helvetica, Arial, sans-serif",
//               fontWeight: 800,
//               fontSize: "1.75rem",
//               mb: 1,
//             }}
//           >
//             Develop locally, deploy globally
//             <span style={{ fontSize: "1rem", verticalAlign: "super" }}>®</span>
//           </Typography>

//           <Typography
//             variant="body1"
//             sx={{
//               fontFamily: "Inter, Helvetica, Arial, sans-serif",
//               fontSize: "1rem",
//               color: COLORS.textSecondary,
//               mb: 6,
//             }}
//           >
//             32 cloud data center regions
//           </Typography>

//           <Box
//             sx={{
//               position: "relative",
//               display: "inline-block",
//               width: "90%",
//               maxWidth: "950px",
//               mx: "auto",
//             }}
//           >
//             <Box
//               component="img"
//               src="/worldmap.svg"
//               alt="World map"
//               sx={{ width: "100%", height: "auto", opacity: 0.95 }}
//             />

//             {/* Circular badge — purple accent */}
//             <Box
//               sx={{
//                 position: "absolute",
//                 top: "25%",
//                 right: "10%",
//                 background: COLORS.glassBg,
//                 borderRadius: "50%",
//                 width: 120,
//                 height: 120,
//                 boxShadow: COLORS.glassShadow,
//                 display: "flex",
//                 flexDirection: "column",
//                 justifyContent: "center",
//                 alignItems: "center",
//               }}
//             >
//               <Typography
//                 sx={{
//                   fontFamily: "Inter, Helvetica, Arial, sans-serif",
//                   color: COLORS.primary,
//                   fontWeight: 800,
//                   fontSize: "2.25rem",
//                   lineHeight: 1.2,
//                 }}
//               >
//                 32
//               </Typography>
//               <Typography
//                 sx={{
//                   fontFamily: "Inter, Helvetica, Arial, sans-serif",
//                   color: COLORS.textSecondary,
//                   fontSize: "0.95rem",
//                 }}
//               >
//                 regions
//               </Typography>
//             </Box>
//           </Box>

//           <Button
//             variant="outlined"
//             sx={{
//               mt: 6,
//               color: COLORS.primary,
//               borderColor: COLORS.primary,
//               fontFamily: "Inter, Helvetica, Arial, sans-serif",
//               fontWeight: 700,
//               fontSize: "0.95rem",
//               textTransform: "none",
//               px: 3.5,
//               py: 1.3,
//               borderRadius: "12px",
//               backdropFilter: "blur(6px)",
//               background: "rgba(255,255,255,0.6)",
//               "&:hover": {
//                 borderColor: COLORS.primary,
//                 backgroundColor: COLORS.primaryLight,
//               },
//             }}
//           >
//             Explore regions
//           </Button>
//         </Container>
//       </Box>

//       {/* ===== Banner (Serverless Inference) — purple glass ===== */}
//       <Box sx={{ textAlign: "center", py: 6 }}>
//         <Box
//           sx={{
//             mx: "auto",
//             maxWidth: "1100px",
//             borderRadius: "20px",
//             px: { xs: 3, md: 6 },
//             py: 4,
//             color: COLORS.textPrimary,
//             background: COLORS.glassBg,
//             backdropFilter: "blur(10px)",
//             boxShadow: COLORS.glassShadow,
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//             gap: 3,
//             flexWrap: "wrap",
//           }}
//         >
//           <Box sx={{ textAlign: "left" }}>
//             <Typography
//               variant="h6"
//               sx={{
//                 fontFamily: "Inter, Helvetica, Arial, sans-serif",
//                 fontWeight: 800,
//                 fontSize: "1.05rem",
//                 mb: 0.5,
//               }}
//             >
//               AI NOVA Serverless Inference
//             </Typography>
//             <Typography
//               variant="body2"
//               sx={{
//                 fontFamily: "Inter, Helvetica, Arial, sans-serif",
//                 fontSize: "0.95rem",
//                 color: COLORS.textSecondary,
//               }}
//             >
//               Deploy and scale AI models rapidly and securely without the
//               complexities of infrastructure management.
//             </Typography>
//           </Box>

//           <Button
//             sx={{
//               textTransform: "none",
//               fontFamily: "Inter, Helvetica, Arial, sans-serif",
//               fontWeight: 700,
//               fontSize: "0.95rem",
//               borderRadius: "12px",
//               px: 4,
//               py: 1.2,
//               background: `linear-gradient(90deg, ${COLORS.primary} 0%, ${COLORS.primaryHover} 100%)`,
//               color: "#fff",
//               boxShadow: "0 8px 24px rgba(138,79,255,0.35)",
//               "&:hover": {
//                 background: `linear-gradient(90deg, ${COLORS.primaryHover} 0%, ${COLORS.primary} 100%)`,
//               },
//             }}
//           >
//             Learn more
//           </Button>
//         </Box>
//       </Box>

//       {/* ===== Full Stack Cloud Compute (tabs layout) ===== */}
//        <Box sx={{ textAlign: "center", py: 6, display: "flex", justifyContent: "center" }}>
//       <Box sx={{ py: 10, display: "flex", justifyContent: "center", maxWidth: "1300px" }}>
//         <Container
//           maxWidth="xl"
//           sx={{
//             display: "flex",
//             flexWrap: { xs: "wrap", md: "nowrap" },
//             alignItems: "flex-start",
//             justifyContent: "space-between",
//             gap: 6,
//           }}
//         >
//           {/* Left column */}
//           <Box sx={{ flex: "1 1 40%", textAlign: "left" }}>
//             <Typography
//               variant="h4"
//               sx={{
//                 fontFamily: "Inter, Helvetica, Arial, sans-serif",
//                 fontWeight: 800,
//                 fontSize: "1.75rem",
//                 color: COLORS.textPrimary,
//                 mb: 2,
//               }}
//             >
//               Full Stack Cloud Compute
//             </Typography>
//             <Typography
//               variant="body1"
//               sx={{
//                 fontFamily: "Inter, Helvetica, Arial, sans-serif",
//                 fontSize: "1rem",
//                 color: COLORS.textSecondary,
//                 mb: 3,
//                 maxWidth: 420,
//               }}
//             >
//               Build a composable cloud according to your business needs.
//             </Typography>

//             <Button
//               variant="outlined"
//               sx={{
//                 color: COLORS.primary,
//                 borderColor: COLORS.primary,
//                 textTransform: "none",
//                 fontFamily: "Inter, Helvetica, Arial, sans-serif",
//                 fontWeight: 700,
//                 fontSize: "0.95rem",
//                 borderRadius: "12px",
//                 px: 3.5,
//                 py: 1.2,
//                 background: "rgba(255,255,255,0.65)",
//                 backdropFilter: "blur(6px)",
//                 "&:hover": {
//                   borderColor: COLORS.primary,
//                   backgroundColor: COLORS.primaryLight,
//                 },
//               }}
//             >
//               Learn more
//             </Button>
//           </Box>

//           {/* Right column (tabs card) */}
//           <Box
//             sx={{
//               flex: "1 1 55%",
//               display: "flex",
//               borderRadius: "14px",
//               overflow: "hidden",
//               maxWidth: "700px",
//               background: COLORS.glassBg,
//               backdropFilter: "blur(10px)",
//               boxShadow: COLORS.glassShadow,
//             }}
//           >
//             {/* Left tabs */}
//             <Box
//               sx={{
//                 width: "45%",
//                 borderRight: "1px solid rgba(138,79,255,0.15)",
//                 py: 3,
//                 background:
//                   "linear-gradient(180deg, rgba(138,79,255,0.10), rgba(255,255,255,0))",
//               }}
//             >
//               {[
//                 "Cloud Compute",
//                 "AI NOVA VX1™ Cloud Compute",
//                 "Optimized Cloud Compute",
//                 "Bare Metal",
//                 "Kubernetes",
//                 "Managed Databases",
//                 "Storage",
//               ].map((item, i) => (
//                 <Typography
//                   key={i}
//                   sx={{
//                     fontFamily: "Inter, Helvetica, Arial, sans-serif",
//                     fontSize: "0.95rem",
//                     px: 3,
//                     py: 1.5,
//                     cursor: "pointer",
//                     color: i === 0 ? COLORS.primary : COLORS.textPrimary,
//                     backgroundColor: i === 0 ? COLORS.primaryLight : "transparent",
//                     borderRadius: i === 0 ? "10px" : 0,
//                     fontWeight: i === 0 ? 800 : 500,
//                     mx: 1.5,
//                     transition: "all 0.2s ease",
//                     "&:hover": {
//                       backgroundColor: COLORS.primaryLight,
//                     },
//                   }}
//                 >
//                   {item}
//                 </Typography>
//               ))}
//             </Box>

//             {/* Right panel */}
//             <Box sx={{ width: "55%", p: 4 }}>
//               <Typography
//                 variant="h6"
//                 sx={{
//                   fontFamily: "Inter, Helvetica, Arial, sans-serif",
//                   fontWeight: 800,
//                   color: COLORS.textPrimary,
//                   mb: 1,
//                   fontSize: "1.05rem",
//                 }}
//               >
//                 Cloud Compute
//               </Typography>
//               <Typography
//                 variant="body2"
//                 sx={{
//                   fontFamily: "Inter, Helvetica, Arial, sans-serif",
//                   fontSize: "0.95rem",
//                   color: COLORS.textSecondary,
//                   mb: 3,
//                 }}
//               >
//                 Build a composable cloud according to your business needs.
//               </Typography>

//               <Button
//                 sx={{
//                   background: `linear-gradient(90deg, ${COLORS.primary} 0%, ${COLORS.primaryHover} 100%)`,
//                   color: "#fff",
//                   textTransform: "none",
//                   fontFamily: "Inter, Helvetica, Arial, sans-serif",
//                   fontWeight: 700,
//                   fontSize: "0.9rem",
//                   borderRadius: "12px",
//                   px: 3,
//                   py: 1.1,
//                   boxShadow: "0 8px 24px rgba(138,79,255,0.35)",
//                   "&:hover": {
//                     background: `linear-gradient(90deg, ${COLORS.primaryHover} 0%, ${COLORS.primary} 100%)`,
//                   },
//                 }}
//               >
//                 Learn more
//               </Button>
//             </Box>
//           </Box>
//         </Container>
//       </Box>
//       </Box>

//       {/* ===== Info Banner #2 (VX1) ===== */}
//       <Box sx={{ textAlign: "center", py: 6 }}>
//         <Box
//           sx={{
//             mx: "auto",
//             maxWidth: "1100px",
//             borderRadius: "20px",
//             px: { xs: 3, md: 6 },
//             py: 4,
//             color: COLORS.textPrimary,
//             background: COLORS.glassBg,
//             backdropFilter: "blur(10px)",
//             boxShadow: COLORS.glassShadow,
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//             gap: 3,
//             flexWrap: "wrap",
//           }}
//         >
//           <Box sx={{ textAlign: "left" }}>
//             <Typography
//               variant="h6"
//               sx={{
//                 fontFamily: "Inter, Helvetica, Arial, sans-serif",
//                 fontWeight: 800,
//                 fontSize: "1.05rem",
//                 mb: 0.5,
//               }}
//             >
//               AI NOVA VX1™ Cloud Compute
//             </Typography>
//             <Typography
//               variant="body2"
//               sx={{
//                 fontFamily: "Inter, Helvetica, Arial, sans-serif",
//                 fontSize: "0.95rem",
//                 color: COLORS.textSecondary,
//               }}
//             >
//               Deploy workloads on enterprise-grade CPU infrastructure with
//               industry-leading cost efficiency.
//             </Typography>
//           </Box>

//           <Button
//             sx={{
//               textTransform: "none",
//               fontFamily: "Inter, Helvetica, Arial, sans-serif",
//               fontWeight: 700,
//               fontSize: "0.95rem",
//               borderRadius: "12px",
//               px: 4,
//               py: 1.2,
//               background: `linear-gradient(90deg, ${COLORS.primary} 0%, ${COLORS.primaryHover} 100%)`,
//               color: "#fff",
//               boxShadow: "0 8px 24px rgba(138,79,255,0.35)",
//               "&:hover": {
//                 background: `linear-gradient(90deg, ${COLORS.primaryHover} 0%, ${COLORS.primary} 100%)`,
//               },
//             }}
//           >
//             Learn more
//           </Button>
//         </Box>
//       </Box>

//       {/* ===== Footer (lavender gradient) ===== */}
//       <Box
//         sx={{
//           background:
//             "linear-gradient(135deg, #efe6ff 0%, #e1d2ff 50%, #f6f0ff 100%)",
//           color: COLORS.textPrimary,
//           pt: 8,
//           pb: 5,
//           px: { xs: 4, md: 10 },
//           borderTopLeftRadius: "24px",
//           borderTopRightRadius: "24px",
//           boxShadow: COLORS.glassShadow,
//           mt: 6,
//         }}
//       >
//         <Container maxWidth="xl">
//           <Grid container spacing={5}>
//             <Grid item xs={12} md={4}>
//               <Box sx={{ mb: 2 }}>
//                 <img
//                   src="/ainova_logo_white.png"
//                   alt="AI NOVA Logo"
//                   style={{ height: 48, marginBottom: 10 }}
//                 />
//               </Box>
//               <Typography
//                 sx={{
//                   fontFamily: "Inter, Helvetica, Arial, sans-serif",
//                   fontSize: "0.95rem",
//                   color: COLORS.textSecondary,
//                   mb: 2,
//                 }}
//               >
//                 Endless Core Energy, Constantly Empowering New Life
//               </Typography>
//             </Grid>

//             <Grid item xs={12} sm={4} md={2}>
//               <FooterHeading>Services</FooterHeading>
//               <FooterLink>Our Solutions</FooterLink>
//               <FooterLink>Our Services</FooterLink>
//             </Grid>

//             <Grid item xs={12} sm={4} md={2}>
//               <FooterHeading>Quick Links</FooterHeading>
//               <FooterLink>About Us</FooterLink>
//               <FooterLink>Contact Us</FooterLink>
//             </Grid>

//             <Grid item xs={12} sm={12} md={4}>
//               <FooterHeading>Contacts</FooterHeading>
//               <Typography sx={{ fontSize: "0.9rem", mb: 0.5 }}>
//                 <strong>Address:</strong> 2750 Quadra Street Victoria, Canada
//               </Typography>
//               <Typography sx={{ fontSize: "0.9rem", mb: 0.5 }}>
//                 <strong>Email:</strong> opstar@gmail.com
//               </Typography>
//               <Typography sx={{ fontSize: "0.9rem", mb: 0.5 }}>
//                 <strong>Phone:</strong> +44 587 154756
//               </Typography>
//               <Typography sx={{ fontSize: "0.9rem" }}>
//                 <strong>Fax:</strong> +44 785 4578964
//               </Typography>
//             </Grid>
//           </Grid>

//           <Box
//             sx={{
//               borderTop: "1px solid rgba(42,15,76,0.15)",
//               mt: 6,
//               pt: 3,
//               display: "flex",
//               flexWrap: "wrap",
//               justifyContent: "space-between",
//               alignItems: "center",
//               gap: 2,
//             }}
//           >
//             <Typography
//               sx={{
//                 fontFamily: "Inter, Helvetica, Arial, sans-serif",
//                 fontSize: "0.85rem",
//                 color: COLORS.textSecondary,
//               }}
//             >
//               ©2025 AINOVA. All Rights Reserved.
//             </Typography>

//             <Box sx={{ display: "flex", gap: 2 }}>
//               <FooterLink>Privacy Policy</FooterLink>
//               <FooterLink>Terms & Conditions</FooterLink>
//             </Box>
//           </Box>
//         </Container>
//       </Box>
//     </Box>
//   );
// }

// /* ===== Reusable bits ===== */

// function GlassInput({ label, type = "text" }) {
//   return (
//     <TextField
//       label={label}
//       type={type}
//       variant="filled"
//       size="small"
//       InputProps={{
//         disableUnderline: true,
//         sx: {
//           bgcolor: "rgba(255,255,255,0.9)",
//           borderRadius: "12px",
//           px: 1.5,
//           backdropFilter: "blur(6px)",
//           "& input": {
//             color: "#2a0f4c",
//             fontFamily: "Inter, Helvetica, Arial, sans-serif",
//             fontWeight: 600,
//           },
//         },
//       }}
//       InputLabelProps={{
//         sx: {
//           color: "rgba(42,15,76,0.6)",
//           fontFamily: "Inter, Helvetica, Arial, sans-serif",
//         },
//       }}
//       sx={{ width: 240 }}
//     />
//   );
// }

// function NavButton({ text, variant }) {
//   const baseStyle = {
//     fontFamily: "Inter, Helvetica, Arial, sans-serif",
//     fontWeight: 700,
//     fontSize: "0.9rem",
//     textTransform: "none",
//     borderRadius: "12px",
//     px: 2.5,
//     py: 0.9,
//     boxShadow: "none",
//     transition: "all 0.2s ease-in-out",
//   };

//   if (variant === "contained") {
//     return (
//       <Button
//         sx={{
//           ...baseStyle,
//           color: "#fff",
//           background: `linear-gradient(90deg, ${COLORS.primary} 0%, ${COLORS.primaryHover} 100%)`,
//           boxShadow: "0 6px 18px rgba(138,79,255,0.35)",
//           "&:hover": {
//             background: `linear-gradient(90deg, ${COLORS.primaryHover} 0%, ${COLORS.primary} 100%)`,
//           },
//         }}
//       >
//         {text}
//       </Button>
//     );
//   }

//   if (variant === "outlined") {
//     return (
//       <Button
//         sx={{
//           ...baseStyle,
//           color: COLORS.textPrimary,
//           border: `1px solid ${COLORS.primary}`,
//           background: "rgba(255,255,255,0.6)",
//           backdropFilter: "blur(6px)",
//           "&:hover": {
//             background: COLORS.primaryLight,
//             borderColor: COLORS.primary,
//           },
//         }}
//       >
//         {text}
//       </Button>
//     );
//   }

//   if (variant === "bright") {
//     return (
//       <Button
//         sx={{
//           ...baseStyle,
//           color: "#fff",
//           background: `linear-gradient(90deg, #b38aff 0%, #7b5aff 100%)`,
//           boxShadow: "0 6px 18px rgba(138,79,255,0.35)",
//           "&:hover": {
//             background: `linear-gradient(90deg, #7b5aff 0%, #b38aff 100%)`,
//           },
//         }}
//       >
//         {text}
//       </Button>
//     );
//   }

//   return null;
// }

// function FooterHeading({ children }) {
//   return (
//     <Typography
//       sx={{
//         fontFamily: "Inter, Helvetica, Arial, sans-serif",
//         fontWeight: 800,
//         fontSize: "1rem",
//         mb: 1,
//         borderBottom: `2px solid ${COLORS.primary}`,
//         display: "inline-block",
//       }}
//     >
//       {children}
//     </Typography>
//   );
// }

// function FooterLink({ children }) {
//   return (
//     <Typography
//       sx={{
//         fontFamily: "Inter, Helvetica, Arial, sans-serif",
//         fontSize: "0.95rem",
//         color: COLORS.textSecondary,
//         my: 0.7,
//         cursor: "pointer",
//         "&:hover": { color: COLORS.textPrimary },
//       }}
//     >
//       {children}
//     </Typography>
//   );
// }
import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  Navigate,
} from "react-router-dom";

// ===== 导入组件 =====
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Products from "./components/Products";
import VisionMission from "./components/VisionMission";
import EmpowerCustomers from "./components/EmpowerCustomers";
import Regions from "./components/Regions";
import InfoBanner from "./components/InfoBanner";
import InfoBanner2 from "./components/InfoBanner2";
import FullStackCompute from "./components/FullStackCompute";
import Footer from "./components/Footer";
import BackToTopButton from "./components/BackToTopButton";
import AboutUs from "./components/AboutUs";
import OurSolutions from "./components/OurSolutions";
import OurSolutions2 from "./components/OurSolutions2";
import OurTeam from "./components/OurTeam";
import Investor from "./components/Investor";
import OurPartners from "./components/OurPartnersNew";
import NewsEvents from "./components/NewsEvents";
import LoginPage from "./components/Login";
import SignUpPage from "./components/Signup";
import Dashboard from "./components/Dashboard";
import Privacy from "./components/privacy";
import ContactUs from "./components/contactUs";
import OurPillars from "./components/OurPillars";
import OurReach from "./components/OurReach";
import OurReach2 from "./components/OurReach2";
import HeroSection from "./components/HeroSection";

// 👇 新增：AuthProvider 和 PrivateRoute
import { AuthProvider } from "./context/AuthContext";
import PrivateRoute from "./components/PrivateRoute";
import CloudGPU from "./components/cloud-gpu";
import CloudCompute from "./components/CloudCompute";
import OptimizedCloudCompute from "./components/OptimizedCloudCompute";
import BareMetal from "./components/BareMetal";
// ======= 包含路由逻辑的内部组件 =======
function AppContent() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "auto", // 想要滑动效果就改成 "smooth"
    });
  }, [location.pathname]);

  // login / signup / dashboard 隐藏 Navbar & Footer
  const hideLayout = ["/login", "/signup", "/dashboard"].includes(
    location.pathname
  );

  return (
    <div className="min-h-screen flex flex-col bg-white">
      {/* ===== Navbar ===== */}
      {!hideLayout && <Navbar />}

      {/* ===== 路由配置 ===== */}
      <Routes>
        {/* 首页 */}
        <Route
          path="/"
          element={
            <>
              <div className="bg-purple-50">
                <Hero />
              </div>
              <div className="bg-white">
                {/* <Products />
                <VisionMission /> */}
                <EmpowerCustomers />
                <OurSolutions2 />
                <OurReach2 />
                {/* <Regions /> */}

                {/* <div className="bg-purple-100">
                  <InfoBanner
                    title="Our Global Reach, Local Proximity"
                    text="Explore AI NOVA Data center regions across Asia and beyond to deploy compute closer to your users."
                  />
                </div> */}

                {/* <FullStackCompute /> */}
                <HeroSection />

                {/* <div className="bg-gradient-to-b from-purple-100 via-white to-purple-50 ">
                  <InfoBanner2
                    title="AI NOVA NX1 Cloud Compute"
                    text="Deploy workloads on enterprise-grade CPU infrastructure with industry-leading cost efficiency."
                  />
                </div> */}
              </div>
            </>
          }
        />

        {/* 其他公开页面 */}
        <Route path="/about" element={<AboutUs />} />
        <Route path="/our-solutions" element={<OurSolutions />} />
        <Route path="/our-solutions2" element={<OurSolutions2 />} />
        <Route path="/team" element={<OurTeam />} />
        <Route path="/investor" element={<Investor />} />
        <Route path="/partners" element={<OurPartners />} />
        <Route path="/news" element={<NewsEvents />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<SignUpPage />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/cloud-gpu" element={<CloudGPU />} />
        <Route path="/cloud-compute" element={<CloudCompute />} />
        <Route path="/our-pillars" element={<OurPillars />} />
        <Route path="/our-reach" element={<OurReach />} />
        <Route path="/our-reach2" element={<OurReach2 />} />
        <Route
          path="/optimized-cloud-compute"
          element={<OptimizedCloudCompute />}
        />
        <Route path="/bare-metal" element={<BareMetal />} />
        {/* 受保护路由：必须登录 */}
        <Route element={<PrivateRoute />}>
          <Route path="/dashboard" element={<Dashboard />} />
          {/* 以后还有别的需要登录的页面也可以加在这里 */}
        </Route>

        {/* 未匹配路径，统一跳回首页或登录 */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>

      {/* ===== Footer ===== */}
      {!hideLayout && <Footer />}
    </div>
  );
}

// ======= 外层包裹 Router + AuthProvider =======
export default function App() {
  return (
    <Router>
      <AuthProvider>
        <AppContent />
        <BackToTopButton />
      </AuthProvider>
    </Router>
  );
}
